import { useLang } from "@/context/LanguageContext";
import { Reveal, SectionKicker } from "./Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQ = () => {
  const { t } = useLang();
  const f = t.faq;

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 sm:py-32 bg-[#050505]"
    >
      <div className="container-x grid lg:grid-cols-[0.8fr_1.2fr] gap-12">
        <Reveal>
          <SectionKicker>{f.kicker}</SectionKicker>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            {f.title}
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full">
            {f.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-white/10"
              >
                <AccordionTrigger className="text-left font-heading text-base sm:text-lg font-medium text-white hover:text-brand hover:no-underline py-5">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-zinc-400 leading-relaxed text-base">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
